var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a",
    {
      staticClass: "sub-collection-tile",
      style: `--delay: ${_vm.transitionDelay}s`,
      attrs: {
        href: `/collections/${_vm.subCollection.collection.handle}`,
        "data-aos": "zoom-in-up"
      }
    },
    [
      _c(
        "div",
        { staticClass: "collection-super__sub-collection__image-wrapper" },
        [
          _vm.image
            ? _c("img", {
                directives: [
                  {
                    name: "lazy",
                    rawName: "v-lazy",
                    value: _vm.image,
                    expression: "image"
                  }
                ],
                staticClass: "collection-super__sub-collection__image",
                attrs: { alt: _vm.imageAlt }
              })
            : _vm._t("svg")
        ],
        2
      ),
      _c("h2", { staticClass: "collection-super__sub-collection__title" }, [
        _c(
          "span",
          { staticClass: "collection-super__sub-collection__title-span" },
          [
            _vm._v(_vm._s(_vm.subCollection.collection.title)),
            _c(
              "span",
              { staticClass: "collection-super__sub-collection__icon" },
              [_c("icon", { attrs: { name: "chevron-right", size: "18px" } })],
              1
            )
          ]
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }